import { UsuariosPlataformaService } from "../../../shared/generated/grpc/plataforma_seguridad_usuarios_plataforma_pb";
import { UsuarioPlataformaResponse } from "../../../shared/response/seguridad/UsuarioPlataformaResponse";
import { UsuarioPlataformaPayload } from "../../../shared/services/api/payload/UsuarioPlataformaPayload";
import { ServiceSaveBase } from "../../../shared/services/base/ServiceSaveBase";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";
import { toUsuarioPlataformaResponse, UsuarioPlataformaService } from "./UsuarioPlataformaService";

/** Alta y edición de usuarios de Plataforma; el resultado reemplaza la fila del listado. */
export class UsuarioPlataformaSaveService extends ServiceSaveBase<UsuarioPlataformaResponse, UsuarioPlataformaPayload> {
  protected readonly cache = UsuarioPlataformaService.instance;

  /**
   * gRPC-Web (`Guardar`): sin `id` crea (contraseña elegida o aleatoria, enviada por correo). Con `id` edita;
   * la contraseña solo cambia si viene. Inactivar o cambiar la contraseña cierra las sesiones del usuario.
   * En Nitrofert el servidor no deja crear y de una edición solo guarda los roles. La marca de superusuario no
   * existe en el contrato (2026-10-14).
   */
  protected async sendSave(p: UsuarioPlataformaPayload): Promise<UsuarioPlataformaResponse> {
    const u = await grpcCall(() => grpcClient(UsuariosPlataformaService).guardar({
      id: p.id ?? undefined,
      nombre: p.nombre,
      email: p.email,
      password: p.password || undefined,
      isActivo: p.isActivo,
      hasSuperAdmin: p.hasSuperAdmin,
      hasComercial: p.hasComercial,
      hasHardware: p.hasHardware,
      hasPilotos: p.hasPilotos,
      hasConductores: p.hasConductores,
      hasOficina: p.hasOficina,
    }));
    return toUsuarioPlataformaResponse(u);
  }
}
